"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M2.426 16h10.881a.72.72 0 0 0 .72-.72V.033h-.537a.717.717 0 0 0-.182-.024h-.277v14.996H2.924V.996h9.115V0H2.647a.72.72 0 0 0-.719.72v14.782c0 .275.222.498.498.498Zm9.677-9.773H3.866V5.23h7.24V3.023H4.863v1.382h-.996V2.026h8.237v4.2ZM4.145 8.949h1.381V7.567H4.145V8.95Zm7.674 0h-1.382V7.567h1.382V8.95Zm-7.674 2.666h1.381v-1.382H4.145v1.382ZM8.673 8.95H7.29V7.567h1.382V8.95ZM7.29 11.615h1.382v-1.382H7.29v1.382Zm4.528 0h-1.382v-1.382h1.382v1.382ZM4.086 13.98h7.791v-.996H4.086v.996Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M20.125 23.986H3.543a.563.563 0 0 1-.562-.562V.899a.9.9 0 0 1 .9-.899h14.31v1.125H4.107v21.736H19.9V1.021c0 .019.003.037.006.054V.127h.225c.493 0 .894.4.894.894v22.066a.9.9 0 0 1-.899.9ZM5.983 9.114h12.028v-5.95H5.983v3.205h1.125V4.29h9.778v3.7H5.983v1.125ZM8.296 13.4h-2.08v-2.08h2.08v2.08Zm7.394 0h2.08v-2.08h-2.08v2.08Zm-7.394 4.015h-2.08v-2.08h2.08v2.08Zm2.657-4.015h2.08v-2.08h-2.08v2.08Zm2.08 4.015h-2.08v-2.08h2.08v2.08Zm2.657 0h2.08v-2.08h-2.08v2.08Zm1.981 3.372H6.315v-1.125H17.67v1.125Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M26.834 31.982H4.725a.75.75 0 0 1-.75-.75V1.199A1.2 1.2 0 0 1 5.175 0h19.081v1.5H5.476v28.982h21.057V1.362c0 .025.003.049.008.07V.17h.299c.658 0 1.193.535 1.193 1.193v29.421a1.2 1.2 0 0 1-1.199 1.199ZM7.978 12.152h16.037V4.217H7.978v4.274h1.5V5.718h13.037v4.933H7.978v1.5Zm3.083 5.714H8.287v-2.774h2.774v2.774Zm9.86 0h2.773v-2.774H20.92v2.774Zm-9.86 5.354H8.287v-2.774h2.774v2.773Zm3.543-5.354h2.774v-2.774h-2.774v2.774Zm2.774 5.354h-2.774v-2.774h2.774v2.773Zm3.542 0h2.774v-2.774H20.92v2.773Zm2.642 4.495H8.42v-1.5h15.142v1.5Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M40.377 47.985H6.945a.945.945 0 0 1-.946-.946V1.624C5.999.728 6.727 0 7.624 0h28.855v1.891H7.891v44.203H40.11V2.146h-.176V.255h.451c.891 0 1.616.725 1.616 1.616v44.49c0 .895-.729 1.624-1.624 1.624ZM12.052 17.998h23.874V6.378H12.052v6.088h1.892V8.27h20.09v7.837H12.053v1.891Zm4.474 8.83H12.33v-4.195h4.196v4.195Zm14.909 0h4.195v-4.195h-4.195v4.195Zm-14.91 8.095H12.33v-4.195h4.196v4.195Zm5.358-8.095h4.195v-4.195h-4.195v4.195Zm4.195 8.095h-4.195v-4.195h4.195v4.195Zm5.357 0h4.195v-4.195h-4.195v4.195Zm3.806 6.61H12.72v-1.892h22.521v1.892Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M53.836 63.98H9.26a1.26 1.26 0 0 1-1.261-1.261V2.166C7.999.971 8.969 0 10.165 0h38.474v2.522H10.52v58.936h42.96V2.862h-.234V.34h.6c1.189 0 2.156.967 2.156 2.155v59.319a2.169 2.169 0 0 1-2.166 2.166ZM16.069 23.998h31.832V8.505H16.07v8.117h2.522v-5.595H45.38v10.449H16.07v2.522Zm5.965 11.773H16.44v-5.594h5.594v5.594Zm19.879 0h5.594v-5.594h-5.594v5.594Zm-19.88 10.793H16.44V40.97h5.594v5.594Zm7.144-10.793h5.594v-5.594h-5.594v5.594Zm5.594 10.793h-5.594V40.97h5.594v5.594Zm7.142 0h5.594V40.97h-5.594v5.594Zm5.075 8.813H16.96v-2.522h30.028v2.522Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconCalculator = function IconCalculator(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Calculator' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "Calculator"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconCalculator.sizes = [16, 24, 32, 48, 64];
IconCalculator.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconCalculator;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@lmig/design-system-icons-react/_cjs/account-experience/Calculator.js
// module id = 1673
// module chunks = 0